module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multi-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    attrs: {
      "size": "sm",
      "list": _vm.cols,
      "label": "display",
      "id": "key",
      "placeholder": "Show/Hide Cols",
      "btnClass": "btn-light"
    },
    domProps: {
      "value": (_vm.selected)
    },
    on: {
      "clear": _vm.clearAll,
      "input": function($event) {
        _vm.selected = $event
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-badcb69c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/ShowHideCols.vue
// module id = 419
// module chunks = 0